var _path, _path2, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVarunaIconTurbidityF(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    fill: "currentcolor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.52,3.42H54.19A50.39,50.39,0,0,0,3.85,53.76V445.1a50.39,50.39,0,0,0,50.34,50.34H445.52a50.39,50.39,0,0,0,50.34-50.34V53.76A50.44,50.44,0,0,0,445.52,3.42Zm-59,416.15c-7.54,13.12-21.76,20.26-39.9,20.26-21.44,0-54.11-.47-88.74-.94-36.28-.47-73.74-1-99.5-1-27.8,0-40.29-11.62-45.87-21.44-10.91-19.16-3.85-44.61,6.52-62,14.14-23.88,66.13-118.43,75-134.61V96.56a10.38,10.38,0,0,1-9.74-10.28,10.49,10.49,0,0,1,10.45-10.45H304.56a10.45,10.45,0,0,1,0,20.89h-3.38V215.86c9.74,17.51,70.44,127.14,83,149.52C394.32,383.45,395.26,404.73,386.55,419.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.62,223.63l-1.33-2.35V96.72H215V225.2l-1.26,2.36c-2.51,4.55-61,111.2-76.64,137.51-7.54,12.72-12.41,30.31-6.29,41,4.09,7.23,13.43,10.84,27.72,10.84,25.84,0,63.46.55,99.74,1,34.56.47,67.15.95,88.43.95,10.68,0,18.06-3.3,21.91-9.9,4.95-8.4,3.85-21.83-2.59-33.38C352.38,351.33,282.33,224.89,281.62,223.63ZM263.56,234a19.08,19.08,0,1,1-19.08,19.08A19.1,19.1,0,0,1,263.56,234Zm92.91,165.7a10.49,10.49,0,0,1-9,5.19h-196a10.42,10.42,0,0,1-9.11-15.47l54.89-100a10.46,10.46,0,0,1,9.19-5.42h84.34a10.42,10.42,0,0,1,9.11,5.27l56.86,100A9.82,9.82,0,0,1,356.47,399.7Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 233.96,
    cy: 329.42,
    r: 19.08,
    transform: "translate(-159.92 419.5) rotate(-67.5)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 279.5,
    cy: 369.08,
    r: 12.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarunaIconTurbidityF);
export default __webpack_public_path__ + "static/media/Varuna_Icon_Turbidity_F.ee5132a4.svg";
export { ForwardRef as ReactComponent };